<template>
    <Teleport to="body">
        <div class="fixed inset-0 w-screen transition-all bg-white z-50 overflow-hidden overscroll-none"
             :class="[show ? 'translate-x-0' : 'translate-x-full']">
            <AppContainer class="h-full pt-0">
                <div class="h-20 flex items-center">
                    <Link class="mr-auto" :href="route('homepage')" @click="emit('close')">
                        <app-logo class="max-w-[150px] max-h-10" theme="dark"></app-logo>
                    </Link>

                    <font-awesome-icon @click="emit('close')"
                                       class="cursor-pointer w-4"
                                       :icon="['far', 'times']"
                                       size="lg"></font-awesome-icon>
                </div>

                <ul class="flex flex-col space-y-12 items-center h-full mt-16">

                    <li v-for="link of links" @click="goTo(link)" class="font-bold">
                        <template v-if="link.route !== 'reviews.create'">
                            {{ link.text }}
                        </template>

                        <AppButton v-else class="w-full">{{ link.text }}</AppButton>
                    </li>
                </ul>
            </AppContainer>
        </div>
    </Teleport>
</template>

<script setup>
import AppContainer from "@/Layouts/AppContainer";
import AppLogo from "@/Components/AppLogo";
import AppButton from "@/Components/AppButton";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {Link} from "@inertiajs/inertia-vue3";
import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";

const props = defineProps({
    show: Boolean
});

const emit = defineEmits(["close"]);

const links = ref([
    {route: "steves-reviews.index", text: "Steve's Reviews"},
    {route: "brands.index", text: "Reviews By Brand"},
    {route: "manufacturers.index", text: "Reviews By Car"},
    {route: "awards", text: "Tyre Seeker Awards"},
    {route: "advice.index", text: "Tyre Help & Advice"},
    {route: "news.index", text: "Tyre News"},
    {route: "reviews.create", text: "Submit a Review"}
]);

const goTo = link => {
    Inertia.get(route(link.route), {}, {
        onSuccess: () => {
            emit("close");
        }
    });
};
</script>

<style scoped>

</style>
